<script>
/* eslint-disable */
export default {
  data() {
    return {
      bannerUrl: ""
    };
  },
  async created() {
    let query = this.$route.query;
    this.$loading();
    if (query.doctorId) localStorage.setItem("doctorId", query.doctorId);
    if (query.productTypeId)
      localStorage.setItem("productTypeId", query.productTypeId);
    if (this.$store.state.ProductLarge.length == 0)
      await this.getProductLarge();
    if (this.$store.state.hotTesting.length == 0) await this.getHotTesting();
    await this.getBanner(query.productTypeId);
    this.$store.state.loadingFlag = false;
    if (!this.$store.state.wxConfigFlag) await this.$wxConfig();
    if (localStorage.getItem("userInfo")) this.$getShoppingNumber();
    // setTimeout(() => {
    //   this.$store.state.transitionName = "slide-left";
    // }, 400);
  },
  methods: {
    /**
     * 获取大类
     */
    getProductLarge() {
      return new Promise((success, error) => {
        this.$http
          .get(`/product/getUserProduct`, {
            params: {
              current: 1,
              size: 10,
              productTypeId:
                localStorage.getItem("productTypeId") || "1280700923675324417"
            }
          })
          .then(res => {
            if (res.data.code == 200) {
              let data = res.data.data;
              let list = data.records;
              for (let i = 0; i < list.length; i++) {
                if (list[i].name == "中枢神经系统脱髓鞘疾病检测") {
                  list[i].name = "中枢神经系统";
                  list[i].name2 = "脱髓鞘疾病检测";
                }
              }
              this.$store.state.ProductLarge = list;
            }
            success();
          })
          .catch(err => {
            error();
          });
      });
    },
    /**
     * 获取热门检测项目
     */
    getHotTesting() {
      return new Promise((success, error) => {
        this.$http
          .get(`/product/getHot`, {
            params: {
              productTypeId:
                localStorage.getItem("productTypeId") || "1280700923675324417"
            }
          })
          .then(res => {
            if (res.data.code == 200) {
              let data = res.data.data;
              this.$store.state.hotTesting = data;
            }
            success();
          })
          .catch(err => {
            error();
          });
      });
    },
    getBanner(id) {
      return new Promise((success, error) => {
        this.$http
          .get(
            `/product-type/baseControllerGetById/${id || "1280700923675324417"}`
          )
          .then(res => {
            if (res.data.code == 200) {
              let data = res.data.data;
              if (data) this.bannerUrl = data.banner;
            }
            success();
          })
          .catch(err => {
            error();
          });
      });
    },
    /**
     * 去到搜索页
     */
    goSearch() {
      this.$router.push({
        name: "search",
        query: {
          productTypeId: localStorage.getItem("productTypeId")
        }
      });
    }
  }
};
</script>
<template>
  <div
    class="index"
  >
    <!-- 导航 -->
    <nav>
      <router-link
        to="/"
        class="item active"
      >我要检测</router-link>
      <router-link
        to="/MyTesting"
        class="item"
      >我的报告</router-link>
    </nav>
    <div class="bannerBox">
      <img
        :src="bannerUrl"
        v-if="bannerUrl"
        class="banner"
      />
    </div>
    <div class="index-content">
      <div
        class="search"
        @click="goSearch"
      >
        <div>搜索检测项目</div>
      </div>
      <div class="Quick-nav-list">
        <div
          class="item"
          v-for="(item,index) in $store.state.ProductLarge"
          :key="index"
          @click="$goProductDetails(item.id,item.productId)"
        >
          <img :src="item.icon" />
          <span>{{item.name}}
            <br>
            {{item.name2}}
          </span>
        </div>
      </div>
      <div class="hot-testing">
        <div class="title">热门检测</div>
        <div class="list">
          <div
            class="item"
            v-for="(item,index) in $store.state.hotTesting"
            :key="index"
            @click="$goProductDetails(item.id,item.productId)"
          >
            <img
              class="icon"
              src="../../assets/images/updataFile/productIcon.png"
            />
            {{item.name}}
            <img
              class="hot"
              src="../../assets/images/updataFile/productHot.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.index {
  background-color: #fff;
  .bannerBox {
    height: 320px;
    margin-top: -134px;
  }
  .banner {
    width: 690px;
    height: 320px;
    margin: 0 auto;
    display: block;
    border-radius: 20px;
    margin-top: -134px;
  }
  .index-content {
    background-color: #f8f8f8;
    .search {
      position: absolute;
      top: 396px;
      left: 50%;
      transform: translateX(-50%);
      width: 590px;
      height: 80px;
      border-radius: 80px;
      box-shadow: 0 0 30px 0px rgba(193, 191, 191, 0.5);
      border: 1PX solid #1968a8;
      display: flex;
      justify-content: space-between;
      font-size: 26px;
      color: #ff0000;
      background: url(../../assets/images/updataFile/search-icon.png) no-repeat
        200px center #fff;
      background-size: 32px;
      div {
        position: absolute;
        top: 50%;
        left: 54%;
        transform: translate(-50%, -50%);
      }
    }
    .Quick-nav-list {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      padding: 60px 30px 50px 30px;
      background-color: #fff;
      .item {
        height: 170px;
        padding-top: 30px;
        text-align: center;
        min-width: 33.33%;
        img {
          width: 86px;
          height: 86px;
          display: block;
          margin: 0 auto;
        }
        span {
          display: block;
          font-size: 26px;
          line-height: 40px;
          padding-top: 10px;
          padding-top: 10px;
        }
      }
    }
    /* 热门项目 */
    .hot-testing {
      background-color: #fff;
      margin-top: 20px;
      padding-left: 30px;
      padding-right: 30px;
      .title {
        padding-top: 30px;
        font-size: 34px;
        font-weight: 700;
      }
      .list {
        padding-top: 30px;
        padding-bottom: 30px;
        .item {
          font-size: 32px;
          line-height: 50px;
          padding-bottom: 20px;
          .icon {
            width: 32px;
            height: 32px;
            vertical-align: middle;
            margin-bottom: 8px;
            margin-right: 6px;
          }
          .hot {
            width: 26px;
            height: 14px;
            vertical-align: middle;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}
</style>


